/* eslint-disable */
import React, { useEffect, useState } from "react";

import Icon from "../components/Icon";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addScreenAction, updateScreenAction } from "../actions";
import {
  INTENDED_APP,
  TANK_GROUND,
  WATER_SOURCE,
  WATER_TYPE,
  GARDEN_TAPS,
  HOME_SIZE,
  IS_MAINS,
} from "../constants";

const { REACT_APP_REGION } = process.env;
const AllUnits = require( `../data/${REACT_APP_REGION}/units1.json` );

let results;
function Results( { screens } ) {
  const getResults = () => {
    const answers = screens.answers;
    const intendedApp = answers.INTENDED_APP;
    const waterType = answers.WATER_TYPE;
    const waterSource = answers.WATER_SOURCE;
    const gardenTaps = answers.GARDEN_TAPS;
    const homeSize = answers.HOME_SIZE;
    const tankGround = answers.TANK_GROUND;
    const isMains = answers.IS_MAINS;

    //  ***** Journey For Tank Water Only And Garden **********
    if (
      waterType === "clean_water" &&
      waterSource === "tank_water" &&
      intendedApp === "garden"
    ) {
      if ( gardenTaps === 1 ) {
        if ( tankGround === "above_ground" || tankGround === "below_ground" ) {
          results = AllUnits.filter( ( unit ) => unit.id === 9510455 );
          return results;
        }
      }
      if ( gardenTaps === 2 ) {
        if ( tankGround === "above_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510456 ||
              unit.id === 9510464 ||
              unit.id === 9510450
          );
          return results;
        }
        if ( tankGround === "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) => unit.id === 9510456 || unit.id === 9510451
          );
          return results;
        }
      }
      if ( gardenTaps === 3 ) {
        if ( tankGround === "above_ground" || tankGround === "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) => unit.id === 9510464 || unit.id === 9510451
          );
          return results;
        }
      }
      if ( gardenTaps === 4 ) {
        if ( tankGround === "above_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510457 ||
              unit.id === 9510465
          );
          return results;
        }
        if ( tankGround === "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) => unit.id === 9510457 || unit.id === 9510465
          );
          return results;
        }
      }
    }

    //  ***** Journey For Mains And Tank Water And Garden **********
    if ( waterSource === "mains_and_tank" && intendedApp === "garden" ) {
      if ( gardenTaps === 1 ) {
        if ( tankGround === "above_ground" || tankGround === "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) => unit.id === 9510458 || unit.id === 9510461
          );
          return results;
        }
      }
      if ( gardenTaps === 2 ) {
        if ( tankGround === "above_ground" ) {
          const filteredData = [
            9510459,
            9510462,
            9510466,
            9510468,
            9510452
          ];

          results = AllUnits.filter( ( unit ) =>
            filteredData.includes( unit.id )
          );

          results.sort( ( a, b ) => {
            const indexA = filteredData.indexOf( a.id );
            const indexB = filteredData.indexOf( b.id );
            return indexA - indexB;
          } );
          return results;
        }
        if ( tankGround === "below_ground" ) {
          const filteredData = [
            9510459,
            9510462,
            9510453,
            9510454,
          ];
          results = AllUnits.filter( ( unit ) => filteredData.includes( unit.id ) );

          results.sort( ( a, b ) => {
            const indexA = filteredData.indexOf( a.id );
            const indexB = filteredData.indexOf( b.id );
            return indexA - indexB;
          } );
          return results;
        }
      }
      if ( gardenTaps === 3 ) {
        if ( tankGround === "above_ground" || "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510466 ||
              unit.id === 9510468 ||
              unit.id === 9510453 ||
              unit.id === 9510454
          );
          return results;
        }
      }
      if ( gardenTaps === 4 ) {
        if ( tankGround === "above_ground" || "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510460 ||
              unit.id === 9510463 ||
              unit.id === 9510467 ||
              unit.id === 9510465
          );
          return results;
        }
      }
    }
    //  ***** Journey For Mains And Tank Water And House And Garden **********

    if (
      waterSource === "mains_and_tank" &&
      intendedApp === "house_and_garden"
    ) {
      if ( homeSize === "small" ) {
        if ( tankGround === "above_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510458 ||
              unit.id === 9510461 ||
              unit.id === 9510459 ||
              unit.id === 9510462 ||
              unit.id === 9510466
          );
          return results;
        }
        if ( tankGround === "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510458 ||
              unit.id === 9510461 ||
              unit.id === 9510459 ||
              unit.id === 9510462 ||
              unit.id === 9510452
          );
          return results;
        }
      }
      if ( homeSize === "medium" ) {
        if ( tankGround === "above_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510466 ||
              unit.id === 9510468 ||
              unit.id === 9510453 ||
              unit.id === 9510454
          );
          return results;
        }
        if ( tankGround === "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510460 ||
              unit.id === 9510463 ||
              unit.id === 9510453 ||
              unit.id === 9510454
          );
          return results;
        }
      }
      if ( homeSize === "large" ) {
        if ( tankGround === "above_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510467 ||
              unit.id === 9510465
          );
          return results;
        }

        if ( tankGround === "below_ground" ) {
          results = AllUnits.filter(
            ( unit ) =>
              unit.id === 9510467 ||
              unit.id === 9510469 ||
              unit.id === 9510460 ||
              unit.id === 9510457
          );
          return results;
        }
      }
    }

    // }
  };

  useEffect( () => { } );
  const mapRes = getResults();

  // join all related products, flatten and only return unique values
  let relatedProducts = [];
  results.forEach( ( result ) => {
    relatedProducts = [...relatedProducts, result.productsRequired];
  } );
  relatedProducts = [...new Set( relatedProducts.flat() )];

  const ProductAddons = require( `../data/${REACT_APP_REGION}/productAddons.json` );

  const productsToKeep = [
    1400610, 1400605, 9502862, 9502863, 1003350, 1003355, 3415088
  ];
  const sortedRelatedProducts = relatedProducts.sort( ( a, b ) => {
    const aIndexOriginal = productsToKeep.indexOf( a );
    const bIndexOriginal = productsToKeep.indexOf( b );
    return aIndexOriginal - bIndexOriginal;
  } );
  let resultGridClass =
    "uk-width-3-4 uk-width-1-1@m uk-child-width-1-1 uk-child-width-1-3@s uk-child-width-1-3@m";
  if ( results.length == 2 ) {
    resultGridClass = "uk-child-width-1-1 uk-child-width-1-3@s";
  }
  if ( results.length == 1 ) {
    resultGridClass = "uk-width-1-1 uk-child-width-1-1 uk-child-width-1-3@s";
  }

  let resultsSlider = "";
  if ( results.length > 3 ) {
    resultsSlider = "uk-slider-container uk-margin-auto";
  }
  return (
    <div id="results" className="uk-text-center">
      <div>
        <div className="">
          <h2 className="c-quiz_head">Pump Selector Tool</h2>
        </div>

        <div
          className="uk-text-center uk-margin-left-auto"
          id="recommended-products"
        >
          <h1 className="uk-margin-medium-bottom c-quiz__question">
            Here are your results
          </h1>
          <div
            uk-slider="finite:true"
            style={{ maxWidth: "800" }}
            className="uk-margin-auto"
          >
            <div className="uk-position-relative">
              <div
                className={
                  resultsSlider + "uk-flex uk-flex-middle uk-margin-auto"
                }
              >
                <ul
                  className={
                    "uk-slider-items " +
                    resultGridClass +
                    " uk-grid uk-grid-small uk-margin-auto "
                  }
                  uk-height-match="target: > li > .uk-card"
                >
                  {results.map( ( item, idx ) => {
                    return (
                      <li key={item.id} id={`unit_${idx}`}>
                        <div className="uk-card uk-card-small uk-card-default uk-flex uk-flex-column uk-flex-1 uk-margin-small-left uk-margin-small-right uk-margin-auto">
                          <div className="uk-card-media-top uk-flex-1">
                            <img
                              src={item.imageUrl}
                              alt={item.title}
                              width={175}
                              className="uk-width"
                            />
                          </div>
                          <div className="uk-card-body uk-flex-1">
                            <h5>{item.title}</h5>
                            <span className="uk-text-small">{item.id}</span>
                          </div>
                          <div className="uk-card-body uk-flex-1 uk-background-muted">
                            <h6>Considerations</h6>
                            <ul className="uk-list">
                              {item.considerations.map(
                                ( consideration, index ) => (
                                  <li key={index}>{consideration}</li>
                                )
                              )}
                            </ul>
                          </div>
                          <div className="uk-card-footer">
                            <a
                              target="_blank"
                              href={item.url ? item.url : "#"}
                              className="uk-button uk-button-default uk-display-block uk-width uk-text-uppercase"
                            >
                              Shop in <Icon iconName={"max-logo"} />
                            </a>
                            <p className="uk-text-small uk-margin-small-top">
                              *varying sizes depending on pipe used
                            </p>
                          </div>
                        </div>
                      </li>
                    );
                  } )}
                </ul>
              </div>
              {results.length > 3 && (
                <>
                  <a
                    className="uk-position-center-left-out uk-position-small"
                    href="#"
                    uk-slidenav-previous="true"
                    uk-slider-item="previous"
                  ></a>
                  <a
                    className="uk-position-center-right-out uk-position-small"
                    href="#"
                    uk-slidenav-next="true"
                    uk-slider-item="next"
                  ></a>
                </>
              )}
            </div>
            <ul className="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
          </div>
        </div>
      </div>

      {relatedProducts && (
        <div
          className="uk-text-center uk-margin-auto uk-margin-medium-top"
          id="required-products"
        >
          <h2 className="uk-margin-medium-bottom">You may also require</h2>

          <div uk-slider="finite: true">
            <div className="uk-position-relative">
              <div className="uk-slider-container uk-flex-middle">
                <ul className="uk-flex uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m uk-grid uk-grid-medium">
                  {sortedRelatedProducts.map( ( productItem ) => {
                    const product = ProductAddons.find(
                      ( product ) => product.id === productItem
                    );

                    return (
                      <li
                        key={productItem}
                        id={productItem}
                        className="uk-flex uk-flex-column"
                      >
                        <a
                          href={product.url}
                          className="uk-card uk-card-small uk-card-default uk-card-hover uk-display-block uk-flex-1"
                          target="_blank"
                        >
                          <div className="uk-card-media-top uk-margin-small-bottom uk-height">
                            <img
                              src={product.imageUrl}
                              alt={product.title}
                              width={175}
                              className="uk-width uk-height"
                            />
                          </div>

                          <div
                            className="uk-card"
                            uk-margin="uk-margin-top uk-flex-1"
                          >
                            <h5 className="">{product.title}</h5>
                          </div>
                          <div className="uk-flex-1 uk-padding-small">
                            <a
                              target="_blank"
                              href={product.url}
                              className="uk-button uk-button-default uk-display-block uk-width uk-text-uppercase"
                            >
                              Shop in <Icon iconName={"max-logo"} />
                            </a>
                          </div>
                        </a>
                      </li>
                    );
                  } )}
                </ul>
              </div>
              <a
                className="uk-position-center-left-out uk-position-small"
                href="#"
                uk-slidenav-previous="true"
                uk-slider-item="previous"
              ></a>
              <a
                className="uk-position-center-right-out uk-position-small"
                href="#"
                uk-slidenav-next="true"
                uk-slider-item="next"
              ></a>
            </div>
            <ul className="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = ( state ) => ( {
  screens: state.questions,
} );

const mapDispatchToProps = ( dispatch ) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
    },
    dispatch
  );
};
export default connect( mapStateToProps, mapDispatchToProps )( Results );
